import { container } from "assets/jss/material-kit-react.js";

const transparencyStyle = theme => ({
  container,
  background: {
    backgroundColor: "#fefefe"
  },
  section: {
    padding: "60px 20px 30px",

    "& h2": {
      color: "#081624",
      marginBottom: 30,
      fontWeight: 600,
      fontFamily: "Open Sans, sans-serif"
    },

    "& p": {
      color: "#666",
      fontSize: 16,
      lineHeight: 2,
      marginBottom: 20
    }
  }
});

export default transparencyStyle;
